import { SET_ORGANIZATION_LIST } from '../types/organization'
import { getOrganizationsAPI } from '../api/organization'
import { addMessageCurry } from '../utils/api'

export const saveOrganizations = (payload) => ({
  type: SET_ORGANIZATION_LIST,
  payload: payload,
})

export const getOrganizations = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getOrganizationsAPI(), dispatch).then((organizations) => {
        dispatch(saveOrganizations({ organizations }))
        resolve(organizations)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/organization.js